import styled from "styled-components";

import ChipItemsContainer from "../../../advanced-search/components/shared/ChipItemsContainer/ChipItemsContainer";

export const StyledLabel = styled.label`
    margin-top: 16px;
    display: block;
    padding-bottom: 4px;
`;

export const StyledInputContainer = styled.div`
    cursor: pointer;
`;

export const StyledChipItemsContainer = styled(ChipItemsContainer)`
    padding-bottom: 8px;
`;

export const StyledContainer = styled.div`
    margin-top: 8px;
`;
